// extracted by mini-css-extract-plugin
export var bodySections = "_4k-8";
export var gray = "_4k-7";
export var green = "_4k-4";
export var iconContainer = "_4k-9";
export var iconWidgetContainer = "_4k-1";
export var phoneIcon = "_4k-2";
export var red = "_4k-5";
export var statusDot = "_4k-3";
export var widgetContainer = "_4k-0";
export var yellow = "_4k-6";